import $ from 'jquery';

export default function convenzioni() {

  function init() {
    $(document).on('click', '.box-convenzioni .box-convenzioni__btn', function() {
      var convenzione = $(this).data("slugify");
      $('.box-convenzioni .box-accordion, .box-convenzioni .box-document').addClass('d-none');

      $('.box-convenzioni .box-convenzioni__btn').removeClass('box-convenzioni__btn--active');
      $(this).addClass('box-convenzioni__btn--active');

      if(convenzione != 'all') {
        $('.box-convenzioni .box-accordion[data-category="'+convenzione+'"').removeClass('d-none');
        $('.box-convenzioni .box-document[data-category="'+convenzione+'"').removeClass('d-none');
      } else {
        $('.box-convenzioni .box-accordion, .box-convenzioni .box-document').removeClass('d-none');
      }
    });
  }
  
  $( document ).ready(function() {
    if($('.box-convenzioni .box-convenzioni__btn').length > 0) {
      init();
    }
  });  
}




























